import React, { Fragment } from 'react';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import Logo from '../../images/opdoLogo';
import {
  LoginForm,
  LoginLabel,
  LoginInput,
  LoginButton,
  LoginAuthError,
  LoginWrapper,
  LeftLoginBody,
  RightLoginBody,
  LoginWelcome,
  LoginWelcomeHeading,
  LoginWelcomeSubHeading,
  AdvantagesWrapper,
} from './style';
import { LoginLoading } from '../loading';
import Slideshow from './advantages';

// ---
// Formik.
// ---

const mapPropsToValues = () => ({
  username: '',
  password: '',
});

const mapPropsToPayload = ({ username, password }) => ({ username, password });

const validationSchema = Yup.object().shape({
  username: Yup.string().required('Bitte geben Sie Ihre Kundennummer ein.'),
  password: Yup.string().required('Bitte geben Sie Ihr Passwort ein.'),
});

const enhance = withFormik({
  validateOnChange: false,
  validationSchema,
  mapPropsToValues,
  mapPropsToPayload,
  displayName: 'LoginForm',
  handleSubmit: (payload, { props, setSubmitting }) => {
    const { loginUser } = props;

    loginUser({ user: payload });
    setSubmitting(false);
  },
});

// ---
// Components
// ---

const InputFeedback = ({ error }) => {
  return <LoginAuthError>{error ? error : ''}</LoginAuthError>;
};

const InputField = ({ error, ...rest }) => (
  <Fragment>
    <LoginInput {...rest} />
    <InputFeedback error={error} />
  </Fragment>
);

const Login = props => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    isAuthenticating,
    authError,
    authErrorMessage,
  } = props;
  return (
    <LoginWrapper>
      <LeftLoginBody>
        <Logo width={200} height={150} />
        <div
          css={`
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          `}
        >
          <LoginWelcome>
            <LoginWelcomeHeading>Willkommen,</LoginWelcomeHeading>
            <LoginWelcomeSubHeading>
              bitte loggen Sie sich in Ihren Account ein.
            </LoginWelcomeSubHeading>
          </LoginWelcome>
          <LoginForm onSubmit={handleSubmit}>
            <LoginLabel>
              <InputField
                id="username"
                type="text"
                placeholder="Kundennummer | ClientID"
                value={values.username}
                error={touched.username && errors.username}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={isAuthenticating || isSubmitting}
              />
            </LoginLabel>
            <LoginLabel>
              <InputField
                id="password"
                type="password"
                placeholder="Passwort | Password"
                value={values.password}
                error={touched.password && errors.password}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={isAuthenticating || isSubmitting}
              />
            </LoginLabel>
            <LoginButton
              type="submit"
              disabled={isAuthenticating || isSubmitting}
            >
              {isAuthenticating ? (
                <div
                  css={`
                    width: 100%;
                    height: 100%;
                  `}
                >
                  <LoginLoading />
                </div>
              ) : (
                'Login'
              )}
            </LoginButton>
            <LoginAuthError>{authError && authErrorMessage}</LoginAuthError>
          </LoginForm>
          <LoginWelcomeSubHeading
            css={{
              width: '100%',
            }}
          >
            Mit dem Login in unseren Online Shop stimmen Sie automatisch unseren{' '}
            <a href="http://www.opticunion.de/impressum">
              Datenschutzrichtlinien
            </a>{' '}
            sowie unseren{' '}
            <a href="http://www.opticunion.de/AGB_AKTUELL_03-2013.pdf">AGBs</a>{' '}
            zu.
          </LoginWelcomeSubHeading>
        </div>
      </LeftLoginBody>
      <RightLoginBody>
        <AdvantagesWrapper>
          <LoginWelcomeHeading
            css={`
              padding-bottom: 32px;
            `}
          >
            Die Vorteile unseres Online Shops
          </LoginWelcomeHeading>
          <Slideshow />
        </AdvantagesWrapper>
      </RightLoginBody>
    </LoginWrapper>
  );
};

export default enhance(Login);



// WEBPACK FOOTER //
// ../shop_main/components/login/index.js